<template>
  <b-row>
    <b-colxx class="disable-text-selection">
      <b-row>
        <b-colxx xxs="12">
          <h1>{{ $t('menu.shop-list') }}</h1>
          <piaf-breadcrumb/>
          <div class="separator mb-5"/>
        </b-colxx>
      </b-row>

      <b-card>
        <b-row class="mb-4">

          <b-colxx xxs="12" md="4" lg="3" xl="3" class="pr-0">
            <div class="form-group has-float-label">
              <v-select :options="searchOption" v-model="searchValue" :reduce="item=>item.value" label="label"
                        :searchable="false"></v-select>
              <span>검색유형</span>
            </div>
          </b-colxx>


          <b-colxx xxs="12" md="6" lg="4" xl="4">
              <b-input-group class="mb-6">

                <b-input :placeholder="searchPlaceholder" v-model="search" @keyup.enter="searchData"/>

                <b-input-group-append>
                  <b-button variant="outline-primary default" v-show="!searchFlag" @click="searchData">
                    {{ $t('button.search') }}
                  </b-button>
                </b-input-group-append>

                <!--                <b-button v-show="!searchFlag" @click="searchData" variant="outline-primary default" size="sm">-->
                <!--                  {{$t('button.search')}}-->
                <!--                </b-button>-->

                <!--                <b-button v-show="searchFlag" @click="searchCancel" variant="outline-primary default" size="sm">-->
                <!--                  {{$t('button.search-cancel')}}-->
                <!--                </b-button>-->
              </b-input-group>
          </b-colxx>

          <div class="newWrap">
            <div class="float-md-right">
              <!--                <span class="text-muted text-small mr-1 mb-2">{{from}}-{{to}} of {{ total }}</span>-->
              <b-dropdown id="ddown2" right :text="`${perPage}`" variant="outline-primary" class="d-inline-block"
                          size="md">
                <b-dropdown-item v-for="(size,index) in pageSizes" :key="index" @click="changePageSize(size)">{{ size }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </b-row>

        <template v-if="isLoad">
          <b-row key="thumb">
            <b-colxx xxs="12" class="mb-3" v-for="(item,index) in storeList" :key="index" :id="item.storeCode">

              <b-card :class="{'d-flex flex-row':true}" no-body>
                <img @click.prevent="clickItem($event,item.storeCode)" style="cursor:pointer; margin: 10px;" :src="item.mainImageUrl" class="list-thumbnail border-0"/>
                <div class="d-flex flex-grow-1 min-width-zero">
                  <div class="newP card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                    <p @click.prevent="clickItem($event,item.storeCode)"  style="cursor:pointer;"  class="mb-0 w-20 truncate">{{ item.basicInfo.storeName }}</p>
                    <p @click.prevent="clickItem($event,item.storeCode)"  style="cursor:pointer;" class="mb-0 text w-20 ">{{ getStoreType(item.basicInfo.storeType) }}</p>
                    <p @click.prevent="clickItem($event,item.storeCode)"  style="cursor:pointer;" class="mb-0 text w-20 ">{{ item.registeredDate.substr(0, 10) }}</p>

                    <div class="w-10">
                      <toggle-button 
                                      v-if="userRoless"
                                      v-model="item.enabled" :value="true"
                                     :labels="{checked: '활성화', unchecked: '비활성화'}"
                                     color="#c11314"
                                     @change="statusChange(item)"
                                     :width="80" :height="30"/>
                    </div>

                    <div class="w-10">
                      <b-button @click.stop @click="deleteStore(item.storeCode)" variant="outline-black">
                        <b-icon icon="trash" scale="1"></b-icon>
                      </b-button>
                    </div>

                  </div>
                </div>
              </b-card>
            </b-colxx>

            <b-colxx xxx="12" class="mb-3" v-if="storeList.length === 0">
              <b-card :class="{'d-flex flex-row':true }" no-body>
                <div class="pl-2 d-flex flex-grow-1 min-width-zero">
                  <div
                    class="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                    <h4 style="text-align:center;width:100%">조회 내용이 없습니다.</h4>
                  </div>
                </div>
              </b-card>
            </b-colxx>
          </b-row>

          <b-row v-if="lastPage > 1">
            <!--          <b-row >-->
            <b-colxx xxs="12">
              <b-pagination
                size="sm"
                align="center"
                :total-rows="total"
                :per-page="perPage"
                v-model="currentPage"
              >
                <template v-slot:next-text>
                  <i class="simple-icon-arrow-right"/>
                </template>
                <template v-slot:prev-text>
                  <i class="simple-icon-arrow-left"/>
                </template>
                <template v-slot:first-text>
                  <i class="simple-icon-control-start"/>
                </template>
                <template v-slot:last-text>
                  <i class="simple-icon-control-end"/>
                </template>
              </b-pagination>
            </b-colxx>
          </b-row>
        </template>

        <template v-else>
          <div class="loading"></div>
        </template>

      </b-card>
    </b-colxx>
  </b-row>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import {
  ThumbListIcon,
  ImageListIcon
} from '../../components/Svg'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import api from "../../constants/api";
import {getStoreType} from '../../utils'
import {ToggleButton} from "vue-js-toggle-button";


export default {
  components: {
    'v-select': vSelect,
    'thumb-list-icon': ThumbListIcon,
    'image-list-icon': ImageListIcon,
    'toggle-button': ToggleButton

  },
  data() {
    return {
      userRoless:true,
      isLoad: false,
      searchFlag: false,
      searchValue: 'StoreNameContaining',
      searchOption: this.setOption !== undefined ? this.setOption : [
        // {label: '브랜드코드', value: 'BrandCode'},
        // {label: '브랜드이름', value: 'BrandNameContaining'},
        {label: '매장코드', value: 'StoreCode'},
        {label: '매장이름', value: 'StoreNameContaining'},
        // {label: '관리자 ID', value: 'ManagerID'}
      ],
      keywordType: 'StoreNameContaining',
      searchPlaceholder: '매장 이름을 입력해 주세요.',
      currentPage: 1,
      perPage: 10,
      search: '',
      total: 0,
      lastPage: 0,
      storeList: [],
      pageSizes: [20, 30, 40],
      statuses: [
        {
          text: 'ON HOLD',
          value: 'ON HOLD'
        },
        {
          text: 'PROCESSED',
          value: 'PROCESSED'
        }
      ],
    }
  },

  computed: {
    ...mapGetters(['currentUser', 'siteName'])
  },

  mounted() {
    this.searchData()
  },

  watch: {
    searchValue(value) {
      if(value == "StoreNameContaining") {
        this.searchPlaceholder = "매장 이름을 입력해 주세요."
      } else {
        this.searchPlaceholder = "매장 코드를 입력해 주세요."
      }
    },

    currentPage() {
      this.searchData()
    }
  },
  created(){
    if(JSON.parse(sessionStorage.getItem('BRAND_USER_INFO')).userRole == "BRAND_MANAGER" || JSON.parse(sessionStorage.getItem('BRAND_USER_INFO')).userRole == "BRAND_ADMIN"){
      this.userRoless = true;
    }else{
      this.userRoless = false;
    }
  },
  methods: {
    getStoreType,

    //검색취소
    searchCancel() {
      this.searchFlag = false;
      this.search = '';
    },


    searchData() {

      this.storeList = []
      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.page)

      const params = {
        keywordType: this.searchValue,
        keyword: this.search,
        pageNumber: this.currentPage - 1,
        pageSize: this.perPage
      }


      this.$http.get(reqURL, {
          params: params,
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }
      ).then(res => {
        
        const _data = res.data.data
        this.storeList = _data.content

        //정렬방식 :
        // 1순위 : 활성화 상단, 비활성화 최하단에 표기
        // 2순위 : 매장명 – ㄱ ㄴ ㄷ  순서
        this.storeList.sort(function(a, b) {
          var o1 = b.activated
          var o2 = a.activated
          var p1 = a.basicInfo.storeName
          var p2 = b.basicInfo.storeName
          if(o1 < o2) return -1;
          if(o1 > o2) return 1;
          if(p1 < p2) return -1;
          if(p1 > p2) return 1;
          return 0;
        });

        this.perPage = _data.size
        this.total = res.data.data.totalElements
        this.lastPage = _data.totalPages

        this.isLoad = true
      }).catch(err => {
        alert(err.response.data.message);

      })
    },

    //활성화,비활성화
    statusChange(item) {

      const params = {storeCode: item.storeCode}

      if(item.enabled) {
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.activate)

        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if(res.data.code === "OK") {
            
          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })

      } else {
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.deactivate)

        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if(res.data.code === "OK") {
            

          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);

        })
      }




    },

    deleteStore(itemId) {
      const params = {storeCode: itemId}

      if(confirm('해당 매장을 삭제하시겠습니까? 삭제된 매장 정보는 복구 할수 없습니다.')) {
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.delete)

        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if(res.data.code === "OK") {
            
            alert("삭제되었습니다. ")
            this.$router.go(0)

          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);

        })


      }
    },
    changePageSize(perPage) {
      this.currentPage = 1
      this.perPage = perPage
    },

    clickItem(event, itemId) {
      this.$router.push(`/${this.siteName}/shop/edit-shop/${itemId}`);
    },

  }


}
</script>
